import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-mercadopago-verify',
  templateUrl: 'dialog-mercadopago-verify.html',
  styleUrls: ['dialog-mercadopago-verify.scss']
})
export class DialogMercadoPagoVerifyComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogMercadoPagoVerifyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  close(): void {
    this.dialogRef.close('close');
  }
}

export interface DialogData {
  title: string;
  message: string;
  attempt: number;
  maxAttempts: number;
  nextIn: number;
  state: 'verifying' | 'failed';
}
